// NOTE: these are hardcoded heights based on design,
// will need to updated manually if the design height changes

// NOTE: this height is for any page with search active
export const HEADER_SPACING_HEIGHT_W_SEARCH = ['87px', null, '107px'];

// NOTE: this height is for any page without search active
export const HEADER_SPACING_HEIGHT = ['47px', null, '107px'];
